var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef, useCallback } from "react";
import { useSnackbar, SnackbarContent } from "notistack";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";
import React from "react";
import "../../scss/main.scss";
import "./alert.scss";
import { Divider, Grid } from "@mui/material";
import { getDateString } from "@/utils/Common";
const BulkOrderError = forwardRef((_a, ref) => {
    var { id, fileStatus } = _a, props = __rest(_a, ["id", "fileStatus"]);
    const { closeSnackbar } = useSnackbar();
    const handleDismiss = useCallback(() => {
        closeSnackbar(id);
    }, [id, closeSnackbar]);
    const handleDownload = useCallback(() => {
        if (fileStatus === null || fileStatus === void 0 ? void 0 : fileStatus.downloadUrl) {
            window.open(fileStatus.downloadUrl, "_blank");
        }
    }, [fileStatus]);
    const orderStatus = [
        { title: "Total orders", count: fileStatus === null || fileStatus === void 0 ? void 0 : fileStatus.totalRecords },
        { title: "Upload successful", count: fileStatus === null || fileStatus === void 0 ? void 0 : fileStatus.validRecords },
        { title: "Errors", count: parseInt(fileStatus === null || fileStatus === void 0 ? void 0 : fileStatus.totalRecords) - parseInt(fileStatus === null || fileStatus === void 0 ? void 0 : fileStatus.validRecords) },
    ];
    return (React.createElement(SnackbarContent, { ref: ref },
        React.createElement(Card, { className: "al_border_error al_card" },
            React.createElement(CardActions, null,
                React.createElement(Grid, { container: true, direction: "row", justifyContent: "space-between", alignItems: "stretch", gap: 1 },
                    React.createElement(Grid, { item: true, container: true, xs: 1, textAlign: "right", justifyItems: "flex-end" },
                        React.createElement(Grid, { item: true, xs: true },
                            React.createElement(IconButton, { size: "small", sx: { paddingTop: 0 } },
                                React.createElement(InfoIcon, { fontSize: "small", className: "al_error" })))),
                    React.createElement(Grid, { item: true, container: true, direction: "row", xs: true },
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(Typography, { variant: "body2", fontWeight: 400, className: "m_font_size_12 al_inactive_message" }, "We have found few errors in the submitted file. Kindly resolve those issues and try again.")),
                        React.createElement(Grid, { item: true, container: true, xs: 12, paddingTop: 2 }, orderStatus.map((count, index) => {
                            return (React.createElement(Grid, { item: true, container: true, direction: "row", xs: 4 },
                                React.createElement(Grid, { item: true, xs: 12 },
                                    React.createElement(Typography, { variant: "body2", fontWeight: 600, className: "m_font_size_12 al_inactive_message" + (index === orderStatus.length - 1 && " al_error") }, count.title)),
                                React.createElement(Grid, { item: true, xs: 12 },
                                    React.createElement(Typography, { variant: "body2", fontWeight: 400, className: "m_font_size_12 al_inactive_message" + (index === orderStatus.length - 1 && " al_error") }, count.count))));
                        }))),
                    React.createElement(Grid, { item: true, container: true, xs: 1, justifyItems: "flex-end" },
                        React.createElement(Grid, { item: true },
                            React.createElement(IconButton, { size: "small", onClick: handleDismiss },
                                React.createElement(CloseIcon, { fontSize: "small", className: "al_close" })))),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Divider, { className: "m_divider" })),
                    React.createElement(Grid, { item: true, container: true, direction: "row", xs: 12, justifyContent: "space-between", alignItems: "center", p: 1 },
                        React.createElement(Grid, { item: true, xs: 1 }),
                        React.createElement(Grid, { item: true, xs: 7 },
                            React.createElement(Typography, { variant: "body2", fontWeight: 400, className: "m_font_size_14 al_inactive_message" },
                                "Updated at : ",
                                (fileStatus === null || fileStatus === void 0 ? void 0 : fileStatus.updatedAt) ? getDateString(+(fileStatus === null || fileStatus === void 0 ? void 0 : fileStatus.updatedAt), "MM-DD-YYYY hh:mm a") : "-")),
                        React.createElement(Grid, { item: true, xs: true },
                            React.createElement(Button, { sx: { textTransform: "none" }, className: "m_active_btn", variant: "contained", onClick: handleDownload }, "Download report"))))))));
});
BulkOrderError.displayName = "BulkOrderError";
export default BulkOrderError;
